import { useRef, useCallback } from 'react'

/**
 * useSearchPreserve
 * ------------------
 * Search/filter/results state ko sessionStorage me preserve karta hai,
 * taaki user kisi dusre route par ja kar wapas aaye to search state
 * waisa ka waisa restore ho jaye (dobara search na karna pade).
 *
 * sessionStorage isliye: same tab me navigation/refresh par data bacha rehta hai,
 * lekin tab/browser band karte hi apne aap clear ho jata hai.
 *
 * Usage:
 *   const { restored, save, clear } = useSearchPreserve("home")
 *
 *   - restored : mount ke time par jo cached data mila (ya null)
 *   - save(obj): jab bhi state change ho, snapshot save karo
 *   - clear()  : cache manually hatana ho to
 */
export default function useSearchPreserve(key) {
    const storageKey = `search-preserve:${key}`

    // Sirf pehli render par ek baar read karo
    const restoredRef = useRef(undefined)
    if (restoredRef.current === undefined) {
        try {
            const raw = sessionStorage.getItem(storageKey)
            restoredRef.current = raw ? JSON.parse(raw) : null
        } catch {
            restoredRef.current = null
        }
    }

    const save = useCallback((data) => {
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(data))
        } catch {
            /* storage full / unavailable — silently ignore */
        }
    }, [storageKey])

    const clear = useCallback(() => {
        try { sessionStorage.removeItem(storageKey) } catch { }
        restoredRef.current = null
    }, [storageKey])

    return { restored: restoredRef.current, save, clear }
}